import React, { useState, useContext } from "react";
import styled, { withTheme } from "styled-components";
import { connect } from "react-redux";
import { useHistory, Link } from 'react-router-dom';

import { AuthDataContext, loginURL, signupURL } from '../dataStore/auth/AuthStore';
import { MixerDesignContext } from '../dataStore/mixers/MixerStore';

import {
  Avatar,
  Grid,
  Hidden,
  Menu,
  MenuItem,
  AppBar as MuiAppBar,
  Button,
  IconButton as MuiIconButton,
  Toolbar,
  Typography,
} from "@mui/material";

import { Alert } from '@mui/material';

import {
  ChevronRight
} from "@mui/icons-material";

import {
  Power
} from "react-feather";

const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
  box-shadow: ${props => props.theme.shadows[1]};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function UserMenu() {
  const [anchorMenu, setAnchorMenu] = useState(null);
  const history = useHistory()
  const auth = useContext(AuthDataContext)
  const mixer = useContext(MixerDesignContext)

  const toggleMenu = event => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleSignOut = () => {
    auth.dispatch({type: 'logout'})
    mixer.dispatch({type: 'resetState'})
    closeMenu()
    window.location.reload(false);
  }

  

  return (
    <React.Fragment>
      <IconButton
        aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
        aria-haspopup="true"
        onClick={toggleMenu}
        color="inherit"
        size="large">
        <Power />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem onClick={() => handleSignOut()}>
          Sign out
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

const Header = ({ onDrawerToggle }) => {
  
  const { authData } = useContext(AuthDataContext)
  const { formData } = useContext(MixerDesignContext)
  
  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center" spacing={2}>
            <Hidden mdUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={onDrawerToggle}
                  size="large">
                  <ChevronRight />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                aria-label="Contact"
                component="a"
                href="https://www.sulzer.com/en/shared/contact/contact-us"
                target="_blank"
              >
                Request Additional Products
              </Button>
            </Grid>
            <Grid item xs />
              <Grid item>
                <IconButton size="small" component={Link} to="/">
                  <Avatar>{authData.first_name.charAt(0)}{authData.last_name.charAt(0)}</Avatar>
                </IconButton>
              </Grid>
              <Grid item>
                <Typography>
                  {authData.first_name} {authData.last_name}
                </Typography>
              </Grid>
              <Grid item>
                <UserMenu />
              </Grid>
          </Grid>
        </Toolbar>
        {formData.isStandard === false && 
          <Alert variant='filled' severity="info">Based on your selections, we are unable to generate pricing online. We encourage you to continue to submit your request for quotation through this app for an expedited response!</Alert>
        }
      </AppBar>
    </React.Fragment>
  );};

export default connect()(withTheme(Header));
